<template>
  <div class="slider">
    <div class="slider-donate text-center">
      {{ $t('Donate') }}
      <div class="d-inline-block donate-points-container"
           :class="{'edit': edit, 'cursor-pointer': isActive}"
           @click.stop="enableEdit" >
        <div v-if="!edit" class="slider-donate-points turquoise">{{ content }}</div>
        <input v-else type="text" class="inline-input" v-model="content"
               :disabled="!isActive"
               @input="handleInput" v-click-outside="disableEdit">
        <span class="bold ml-1 slider-donate-pkt">{{pointsSymbol}}</span>
      </div>
    </div>
    <b-form-input class="mt-4" type="range" :disabled="!isActive" v-model="content"
                  @input="handleInput" min="0" :max="max" :step="isIntegerRoundOffMode ? '1' : '0.01'" />
    <div class="d-flex justify-content-between legend">
      <span><span class="bold">0</span> {{pointsSymbol}}</span>
      <span><span class="bold">{{ max }}</span> {{pointsSymbol}}</span>
    </div>
  </div>
</template>

<script>
  import ClickOutside from 'vue-click-outside'
  import {mapState} from 'vuex';

  export default {
    name: 'DonateRange',
    props: {
      value: [String, Number],
      pointsLeft: Number,
    },
    directives: {
      ClickOutside,
    },
    data() {
      return {
        content: this.value,
        edit: false,
        isActive: true,
      };
    },
    methods: {
      getValue(value) {
        value = value.replace(/[^0-9.,]/g, '');
        value = value.replace(/(\.\d{2}|,\d{2})(\d*)/g, '$1');
        value = value.replace(',', '.');

        if (parseFloat(value) > this.max) {
          return this.max.toString();
        }

        if (parseFloat(value) < 0 || value === '') {
          return "0";
        }

        return value;
      },
      handleInput() {
        this.$emit('input', this.getValue(this.content));
      },
      disableEdit() {
        if (this.edit) {
          this.edit = false;
          if (this.content.charAt(this.content.length - 1) === '.') {
            this.content = this.content.replace('.', '');
          }
        }
      },
      enableEdit() {
        if (this.isActive) {
          this.edit = true;
        }
      },
    },
    computed: {
      ...mapState({
        balance: state => state.auth.user.saldo,
        pointsConfig: state => state.settings.points,
        pointsSymbol() {
          return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
        },
        isIntegerRoundOffMode() {
          return this.pointsConfig.roundOffMode !== "none";
        }
      }),
      console: () => console,
      max() {
        return Math.min(this.balance, this.pointsLeft);
      },
    },
    watch: {
      content(newValue) {
        this.content = this.getValue(newValue);
      },
      value(newValue) {
        this.content = newValue;
      },
    },
  };
</script>

<style scoped>
  .slider-donate {
    font-size: 14px;
    height: 38px;
  }

  @media (max-width: 992px) {
    .slider-donate {
      font-size: 17px;
    }

    .legend {
      font-size: 12px;
    }
  }

  .slider-donate-pkt {
    font-size: 16px;
  }

  .slider-donate-points {
    font-size: 26px;
    width: 135px;
    text-align: right;
    display: inline-block;
    margin-bottom: 2px;
  }

  .donate-points-container {
    height: 38px;
    width: 200px;
    padding-top: 8px;
    margin-left: 10px;
  }

  .donate-points-container.edit {
    border: 2px solid var(--accent-color);
    height: 38px;
    padding-top: 7px;
    margin-top: 8px;
    cursor: unset;
  }

  .inline-input {
    background: unset;
    border: unset;
    width: 135px;
    height: 30px;
    color: var(--accent-color);
    font-size: 26px;
    margin-top: -5px;
    padding-right: 0;
    margin-right: 0;
    text-align: right;
  }

  input[type=range]:focus::-webkit-slider-thumb, input[type=range]::-webkit-slider-thumb {
    background: var(--accent-color);
    width: 26px;
    height: 26px;
    margin-top: -9px
  }

  input[type=range]:focus::-moz-range-thumb, input[type=range]::-moz-range-thumb {
    background: var(--accent-color);
    width: 26px;
    height: 26px;
  }

  input[type=range]:focus::-ms-thumb, input[type=range]::-ms-thumb {
    background: var(--accent-color);
    width: 26px;
    height: 26px;
  }
</style>
